<template>
  <base-sign-page
      title-text="角色"
      :note-text="noteText"
      :column-list="columnList"
      :data-list="dataList"
      @countDataChange="countDataChange"
      :count-fun="countFun"
      :show-search="true"
      :loading="loading"
      :title-menus="titleMenus"
      @clickTitleMenu="clickTitleMenu"
      :table-actions-fixed="true"
      @tableAction="tableAction"
      :table-actions-width="100"
      :table-actions="tableActions"
      table-size="norm"
      :need-pagination="true">
      <FmModal v-model="openDialog" :mask-closable="false" title="角色" width="800px">
      <div style="display: flex;" v-if="chooseData">
        <FmForm style="align-items: flex-start; width: 270px;" label-width="100px">
          <FmFormItem style="width: 100%;" label="角色名">
            <FmInput required v-verifier @verifier="(msg) => verifier = msg" v-model="chooseData.name" placeholder="角色名"></FmInput>
          </FmFormItem>
          <FmFormItem style="width: 100%;" label="类型">
            <!-- <FmInput required v-verifier @verifier="(msg) => verifier = msg" v-model="chooseData.type" placeholder="类型"></FmInput> -->
            <FmSelect required v-verifier v-model="chooseData.type" placeholder="类型">
              <FmOption v-for="item in roleTypes" :key="item.key" :value="item.key" :label="item.label"></FmOption>
            </FmSelect>
          </FmFormItem>
          <FmFormItem style="width: 100%;" label="数据权限配置">
            <!-- <FmInput required v-verifier @verifier="(msg) => verifier = msg" v-model="chooseData.dataAuthorityConfig" placeholder="数据权限配置"></FmInput> -->
            <FmSelect required v-verifier multiple v-model="dataAuthorityConfig" placeholder="数据权限配置">
              <FmOption v-for="item in authTypes" :key="item.key" :value="item.key" :label="item.label"></FmOption>
            </FmSelect>
          </FmFormItem>
        </FmForm>
        <div style="flex: 1;border-left: 1px solid #EEE;padding-left: 20px; margin-left: 20px;max-height: 350px; overflow: auto;background: #FFF;">
          <fm-tree placeholder="菜单权限" :key="treeKey" multiple v-loadingx="loading" :nodes="nodes" search is-checked ref="tree"></fm-tree>
        </div>
      </div>
      <div slot="footer">
        <fm-btn v-loadingx="submiting" :disabled="verifier !== ''" @click="formSubmit">{{chooseData && chooseData.id ? '修改角色' : '新增角色'}}</fm-btn>
      </div>
    </FmModal>
  </base-sign-page>

</template>

<script>
import BaseSignPage from '@/components/base/BaseSignPage'

import {
  roleRequest as request
} from '@/api'

export default {
  components: {
    BaseSignPage
  },
  computed: {
    roleTypes () {
      return [{key: 'norm', label: '普通'}, {key: 'special', label: '特殊'}]
    },
    authTypes () {
      return [{key: 'worker', label: '职工'}, {key: 'org', label: '机构'}]
    },
    nodes () {
      const sysMenus = this.$store.getters.menuList.map(v => v.data)
      const funIds = this.chooseData.funIds
      const checked = this.checked

      let funFn = (funs) => {
        return funs.map(fun => {
          return {
            title: fun.name,
            data: Object.assign({isFun: true}, fun),
            checked: funIds.includes(fun.id)
          }
        })
      }

      let fn = (menu) => {
        return {
          title: menu.name,
          data: Object.assign({isMenu: true}, menu),
          checked: checked.includes(menu.id)
        }
      }

      let result = sysMenus.filter(v => v.pid === 0).map(fn)
      ;(function each (nodes) {
        nodes.forEach(node => {
          if (node.data.funs && node.data.funs.length) {
            node.children = funFn(node.data.funs)
          } else {
            node.children = sysMenus.filter(v => v.pid === node.data.id).map(fn)
            each(node.children)
          }
        })
      })(result)

      return this.nodesKey > 0 ? result : []
     },
    tableActions: {
      get () {
        return [{
          label: '删除',
          key: 'delete'
        },
        {
          label: '修改',
          key: 'edit'
        }].filter(({key}) => this.$authFunsProxy[key])
      }
    },
    formParms: {
      get () {
        let data = [{
          type: 'input',
          label: '角色名',
          key: 'name',
          check: {
            required: true
          }
        },
        {
          type: 'multipleChoose',
          label: '菜单',
          key: 'menuIds',
          selectDatas: this.$store.getters.menuList,
          check: {
            required: true
          }
        }]
        return data
      }
    },
    titleMenus: {
      get () {
        return [{
          key: 'add',
          label: '新增'
        }].filter(({key}) => this.$authFunsProxy[key])
      }
    },
    columnList: {
      get () {
        return [{
          field: 'name',
          sort: true,
          title: '角色名',
          render: (h, rowData) => {
            return h('div', rowData.name === 'admin' ? '超级管理员' : rowData.name)
          }
        },
        {
          field: 'type',
          sort: true,
          title: '类型',
          render: (h, row) => {
            return h('div', (this.roleTypes.find(v => v.key === row.type) || {label: '-'}).label)
          },
          filterMethod () {}
        },
        {
          field: 'dataAuthorityConfig',
          sort: true,
          title: '数据权限配置',
          render: (h, row) => {
            let str = (row.dataAuthorityConfig || '').split(',').map(v => {
              return (this.authTypes.find(a => a.key === v) || {label: ''}).label
            }).join(',')
            return h('div', str || '-')
          },
        }]
      }
    }
  },
  created () {
    if (this.$authFunsProxy.get) {
      this.loadData()
    }
    if (this.$authFunsProxy.edit || this.$authFunsProxy.add) {
      this.$store.dispatch('loadMenuList')
    }
  },
  methods: {
    tableAction (data) {
      this.chooseData = Object.assign({}, data.data)
      this.dataAuthorityConfig = (this.chooseData.dataAuthorityConfig || '').split(',')
      if (this.chooseData && this.chooseData.menus && this.chooseData.menus.length > 0) {
        const checked = (function merge (item) {
          return item.map(v => {
            return [v.id].concat((v.children && v.children.length ? merge(v.children) : []))
          }).flat()
        })(this.chooseData.menus)
        this.$set(this.chooseData, 'menuIds', checked)
        this.checked = [...checked]
      } else {
        this.checked = []
      }
      this.treeKey++
      if (data.action === 'edit') {
        this.openDialog = true
      } else if (data.action === 'delete') {
        this.delData()
      }
    },
    async delData () {
      const result = await this.$dialog.confirm({title: '系统提示', content: '确定删除角色 ' + this.chooseData.name + ' 吗?'})
      if (result) {
        request.del(this.chooseData.id).then(() => {
          this.$notice.info({
            title: '系统提示',
            desc: '角色已删除'
          })
          this.loadData()
        })
      }
    },
    formSubmit () {
      const data = [...this.$refs.tree.checkedList.values()]
      let menuIds = data.filter(({data}) => data.data.isMenu).map(({data}) => data.data.id)
      let funIds = data.filter(({data}) => data.data.isFun).map(({data}) => data.data.id)
      this.$set(this.chooseData, 'menuIds', menuIds)
      this.$set(this.chooseData, 'funIds', funIds)
      this.submiting = true
      if (this.chooseData.id) {
        request.update(this.chooseData.id, {
          name: this.chooseData.name,
          menuIds: this.chooseData.menuIds || [],
          funIds: this.chooseData.funIds || [],
          type: this.chooseData.type,
          dataAuthorityConfig: this.dataAuthorityConfig.join(',')
        }).then(() => {
          this.openDialog = false
          this.submiting = false
          this.$notice.success({
            title: '系统提示',
            desc: '角色修改完成'
          })
          this.loadData()
        })
      } else {
        request.add({
          name: this.chooseData.name,
          menuIds: this.chooseData.menuIds || [],
          funIds: this.chooseData.funIds || [],
          type: this.chooseData.type,
          dataAuthorityConfig: this.dataAuthorityConfig.join(',')
        }).then(() => {
          this.openDialog = false
          this.submiting = false
          this.$notice.success({
            title: '系统提示',
            desc: '角色新增完成'
          })
          this.loadData()
        })
      }
    },
    countFun (data) {
      return data.length
    },
    countDataChange (data) {
      this.noteText = '总数:' + data
    },
    clickTitleMenu (parm) {
      this.chooseData = null
      this.treeKey++
      if (parm === 'add') {
        this.chooseData = {name: '', menuIds: [], funIds: []}
        this.checked = []
        this.dataAuthorityConfig = []
        this.openDialog = true
      }
    },
    loadData () {
      this.loading = true
      let parm = {}
      request.get(parm).then((data) => {
        this.$store.dispatch('setRoleList', data)
        data.forEach(v => v.funIds = (v.funs || []).map(v1 => v1.id))
        this.dataList = data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  },
  data () {
    return {
      verifier: '',
      dataList: [],
      dataAuthorityConfig: [],
      checked: [],
      noteText: '',
      loading: true,
      submiting: false,
      chooseData: null,
      openDialog: false,
      treeKey: 0,
      nodesKey: 1
    }
  }
}
</script>
